# import CompanyFragment from "../fragments/company.graphql"

mutation UpdateCompany($id: ID!, $input: UpdateCompanyInput!) {
  updateCompany(id: $id, input: $input) {
    ...CompanyFragment
  }
}
